import { render } from "./PersonInfoView.vue?vue&type=template&id=7b34afbc&scoped=true"
import script from "./PersonInfoView.vue?vue&type=script&lang=js"
export * from "./PersonInfoView.vue?vue&type=script&lang=js"

import "./PersonInfoView.vue?vue&type=style&index=0&id=7b34afbc&scoped=true&lang=scss"

import exportComponent from "D:\\Code\\MonsterView\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b34afbc"]])

export default __exports__